const DEFAULT_CURRENCY = 'USD';

function normalizeCurrency(currency) {
  return typeof currency === 'string' && currency.trim()
    ? currency.trim().toUpperCase()
    : DEFAULT_CURRENCY;
}

function toFiniteNumber(value) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : undefined;
}

export function minorToMajorAmount(amountMinor) {
  const amount = toFiniteNumber(amountMinor);
  return amount === undefined ? undefined : amount / 100;
}

export function formatMinorCurrency(amountMinor, currency = DEFAULT_CURRENCY) {
  const amountMajor = minorToMajorAmount(amountMinor);
  if (amountMajor === undefined) {
    return undefined;
  }

  return new Intl.NumberFormat('en-US', {
    currency: normalizeCurrency(currency),
    style: 'currency',
  }).format(amountMajor);
}

export function serializePayout(payout = {}) {
  const currency = normalizeCurrency(payout.currency);
  const netAmountCents = toFiniteNumber(payout.amount);
  const costCents = toFiniteNumber(payout.feeTotal);

  return {
    payoutId: payout.charityStackID || payout.payoutID || payout.settlementID || undefined,
    createdDate: payout.createdDate || payout.created || undefined,
    createdDateFormatted: payout.createdDateReadable || undefined,
    arrivalDate: payout.arrivalDate || undefined,
    arrivalDateFormatted: payout.arrivalDateReadable || undefined,
    netAmountCents,
    netAmountDollars: minorToMajorAmount(netAmountCents),
    netAmountFormatted:
      formatMinorCurrency(netAmountCents, currency) || payout.amountFormatted || undefined,
    costCents,
    costDollars: minorToMajorAmount(costCents),
    costFormatted:
      formatMinorCurrency(costCents, currency) || payout.feeTotalFormatted || undefined,
    status: payout.status || undefined,
    currency,
  };
}
